import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const danhmuc = require("../../lib/DanhMucLayer");

class DoiTacEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc quoc gia
      loading_quoctich: true, // co dang loading danh muc quoc gia khong
      source_quoctich: [], //danh muc options cho quoc tich
      loading_tausar: true, // co dang load ding danh muc nguon tin ko
      source_tausar: [], //danh muc options cho nguon tin
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              TenDoiTac: "",
              LoaiDoiTac: props.LoaiDoiTac === undefined ? "1" : props.LoaiDoiTac,
              MaQG: "VNM",
            }
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "TenDoiTac",
      "LoaiDoiTac",
      "MaQG",
    ]);
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    if (this.props.EditMode !== "xoa") {
      var check = danhmuc.validate("doitac", this.state.after);
      console.log("check", check);
      if (!check.error) {
        //console.log(JSON.stringify(this.state.after));
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("doitac/save", danhmuc.chuanHoa("doitac", this.state.after))
          .then((response) => {
            var before = {};
            var after = { ...this.state.after, MaDoiTac: response.MaDoiTac };
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
              saved: true,
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(after);
            }
            this.handleClose(true);
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
      } else {
        this.setState({ validateStatus: check });
      }
    } else {
      //thuc hien xoa
      this.setState({ saving: true, errorLog: "" });
      server
        .post("doitac/xoa", this.state.after)
        .then((response) => {
          var before = {};
          this.setState({
            saving: false,
            errorLog: "",
          });
          this.handleClose(true);
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    }
  };
  componentDidMount() {
    this.loadDanhMuc();
    this.loadEdit();
  }
  loadDanhMuc() {
    //load danh muc quoc gia
    server
      .query("quocgia/getall")
      .then((response) => {
        var list = [{value: null, label: '------'}];
        response.map((item, index) =>
          list.push({ value: item.MaQG, label: item.TenQuocGia })
        );
        this.setState({ source_quoctich: list, loading_quoctich: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_quoctich: false });
      });
  }
  loadEdit() {
    //kiem tra xem co phai che do edit hay khong
    var mask = this.props.MaDoiTac;
    if (mask !== undefined) {
      //load va hien thi thong tin su kien
      server
        .query("doitac/get?maso=" + mask)
        .then((response) => {
          //thong tin su kien
          var sukien = response;
          sukien = danhmuc.chuyenDoi("doitac", sukien); //chuyen doi gia tri
          console.log(sukien, "chuyen doi");
          this.setState({
            formReady: true,
            before: sukien,
            after: myLib.cloneObject(sukien),
          });
          console.log("ket qua truy van", sukien);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_doitac: false, errorLog: error + "" });
        });
    } else {
      this.setState({ formReady: true });
    }
  }
  handleClose = (result) => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose(result);
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Danh mục Đơn vị ngoài
                </Typography>
                {this.props.EditMode === "xoa" ? (
                  <Button color="inherit" onClick={this.handleSave}>
                    Xóa
                  </Button>
                ) : null}
                <Button
                  color="inherit"
                  onClick={() => this.handleClose(this.state.saved === true)}
                >
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              <div style={{ height: 350 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      id="txtTenDoiTac"
                      className={classes.textbox}
                      autoFocus={true}
                      label="Tên đơn vị:"
                      value={this.state.after.TenDoiTac}
                      inputProps={{
                        maxLength: 150,
                      }}
                      onChange={(event) =>
                        this.saveField("TenDoiTac", event.target.value)
                      }
                      error={this.state.validateStatus.TenDoiTac !== undefined}
                      helperText={
                        this.state.validateStatus.TenDoiTac !== undefined
                          ? this.state.validateStatus.TenDoiTac.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-simple-select-label">
                        Phân loại:
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className={classes.textbox}
                        autoWidth={true}
                        labelWidth={100}
                        disabled={this.props.LoaiDoiTac !== undefined}
                        value={this.state.after.LoaiDoiTac}
                        onChange={(event) =>
                          this.saveField("LoaiDoiTac", event.target.value)
                        }
                      >
                        <MenuItem value={"0"}>Khác</MenuItem>
                        <MenuItem value={"1"}>Đài CRS</MenuItem>
                        <MenuItem value={"2"}>MRCC nước ngoài</MenuItem>
                        <MenuItem value={"3"}>Đơn vị trong nước</MenuItem>
                        <MenuItem value={"4"}>Tàu trong khu vực</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel
                      id="labelQuoctich"
                      className={
                        this.state.validateStatus.MaQG !== undefined
                          ? classes.redLabel
                          : classes.normalLabel
                      }
                    >
                      Quốc gia:
                    </InputLabel>
                    {this.state.loading_quoctich ? (
                      <CircularProgress />
                    ) : (
                      <SelectFilter
                        id="cboMaQG"
                        options={this.state.source_quoctich}
                        placeholder="---Chọn---"
                        labelId="labelQuoctich"
                        value={this.state.after.MaQG}
                        onChange={(item) => this.saveField("MaQG", item)}
                      ></SelectFilter>
                    )}
                  </Grid>

                  <Grid item xs={2}>
                    {this.state.canSaved && this.props.EditMode !== "xoa" ? (
                      <MyButton
                        onClick={this.handleSave}
                        color="primary"
                        text="Lưu"
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={10}>
                    {this.state.saving ? (
                      <CircularProgress />
                    ) : this.state.errorLog === "" ? null : (
                      this.state.errorLog
                    )}
                  </Grid>
                </Grid>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 450,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
  normalLabel: {
    color: "black",
  },
  redLabel: {
    color: "red",
  },
});
export default withStyles(styles, { withTheme: true })(DoiTacEditDialog);
